import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shu",
  "use": "icon-shu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shu\"><path d=\"M992 640h-128V480a32 32 0 0 0-32-32H544v-64h192a32 32 0 0 0 32-32v-64a32 32 0 0 0-64 0v32H320V64h384v34.72a32 32 0 1 0 64 0V32a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h192v64H192a32 32 0 0 0-32 32v160H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V672a32 32 0 0 0-32-32h-128v-128h576v128h-128a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V672a32 32 0 0 0-32-32zM320 960H64V704h256z m640 0H704V704h256z\" fill=\"#211b13\" /><path d=\"M416 128a32 32 0 0 0 0 64h128a32 32 0 0 0 0-64z\" fill=\"#ffb243\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shu.svg
// module id = PDl3
// module chunks = 22